import React, { useState, useEffect } from "react";
import L from "leaflet";
import {
	MapContainer,
	Marker,
	Popup,
	TileLayer,
	Circle,
	useMap
} from "react-leaflet";
import "leaflet/dist/leaflet.css";

import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
const MarkerIcon = L.icon({
	iconUrl: icon,
	shadowUrl: iconShadow
});
L.Marker.prototype.options.icon = L.icon({
	iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png"
});

function Map({ co, text }) {
	return (
		<div style={{ height: 450 }}>
			<MapContainer
				scrollWheelZoom={true}
				center={co}
				zoom={17}
				style={{ height: "450px" }}
			>
				<TileLayer
					attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
					url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
				/>
				<Marker position={co} icon={MarkerIcon}>
					<Popup>{text}</Popup>
				</Marker>
			</MapContainer>
		</div>
	);
}

export default Map;
